import { __assign } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives } from "vue";
var _hoisted_1 = { class: "chat-support" };
var _hoisted_2 = { key: 0 };
var _hoisted_3 = { key: 1 };
import { ref, onMounted } from 'vue';
import { io } from 'socket.io-client';
var whatsappNumber = '591TU_NUMERO'; // Número en formato internacional (sin +)
var whatsappMessage = 'Hola, estoy interesado en unirme a una cuenta Netflix.';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ChatSupport',
    setup: function (__props) {
        var socket = io('http://TU_DOMINIO:3000');
        var message = ref('');
        var username = ref('user' + Math.floor(Math.random() * 1000));
        var messages = ref([]);
        var adminOnline = ref(false);
        var whatsappLink = "https://wa.me/".concat(whatsappNumber, "?text=").concat(encodeURIComponent(whatsappMessage));
        onMounted(function () {
            socket.emit('registerUser', username.value);
            socket.on('newMessage', function (payload) {
                messages.value.push(__assign(__assign({}, payload), { timestamp: Date.now() }));
            });
            socket.on('adminStatus', function (status) {
                adminOnline.value = status.online;
            });
        });
        function sendMessage() {
            if (message.value.trim()) {
                socket.emit('sendMessage', {
                    username: username.value,
                    message: message.value,
                });
                message.value = '';
            }
        }
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (adminOnline.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messages.value, function (msg) {
                            return (_openBlock(), _createElementBlock("div", {
                                key: msg.timestamp
                            }, [
                                _createElementVNode("strong", null, _toDisplayString(msg.username) + ":", 1),
                                _createTextVNode(" " + _toDisplayString(msg.message), 1)
                            ]));
                        }), 128)),
                        _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((message).value = $event); }),
                            onKeyup: _withKeys(sendMessage, ["enter"]),
                            placeholder: "Escribe tu mensaje..."
                        }, null, 544), [
                            [_vModelText, message.value]
                        ]),
                        _createElementVNode("button", { onClick: sendMessage }, "Enviar")
                    ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _cache[1] || (_cache[1] = _createElementVNode("p", null, "Actualmente no estamos en línea. Escríbenos por WhatsApp:", -1)),
                        _createElementVNode("a", {
                            href: whatsappLink,
                            target: "_blank",
                            class: "whatsapp-button"
                        }, "Contactar por WhatsApp")
                    ]))
            ]));
        };
    }
});
